import { useTheme } from '@emotion/react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { ICellRendererParams } from 'ag-grid-community';
import { CellTextWrapper, EditCell, IconButton } from './EditCellRenderer.styles';

export const EditCellRenderer = (props: ICellRendererParams) => {
  const theme = useTheme();

  return (
    <EditCell>
      <CellTextWrapper>{props.value}</CellTextWrapper>
      <IconButton aria-label='edit'>
        <EditOutlinedIcon htmlColor={theme.colors.blue} />
      </IconButton>
    </EditCell>
  );
};
